// extracted by mini-css-extract-plugin
export default {"modalContainer":"BrYsJ","closeButton":"pkyux"};